// Convertir les dates Air Reviews au format textuel français
function convertirDatesAirReviews() {
  const mois = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  
  // Chercher tous les éléments contenant des dates au format MM/DD/YYYY ou DD/MM/YYYY
  const allElements = document.querySelectorAll('*');
  
  allElements.forEach(function(element) {
    // Vérifier seulement les nœuds de texte
    if (element.childNodes.length > 0) {
      element.childNodes.forEach(function(node) {
        if (node.nodeType === 3) { // Nœud de texte
          const text = node.textContent;
          // Détecter format MM/DD/YYYY (américain)
          const regex = /(\d{2})\/(\d{2})\/(\d{4})/g;
          
          if (regex.test(text)) {
            const newText = text.replace(/(\d{2})\/(\d{2})\/(\d{4})/g, function(match, p1, p2, p3) {
              const moisNum = parseInt(p1) - 1;
              const jour = parseInt(p2);
              const annee = p3;
              
              if (moisNum >= 0 && moisNum < 12) {
                return jour + ' ' + mois[moisNum] + ' ' + annee;
              }
              return match;
            });
            node.textContent = newText;
          }
        }
      });
    }
  });
}

// Exécuter au chargement de la page
document.addEventListener('DOMContentLoaded', convertirDatesAirReviews);

// Exécuter aussi après un délai pour les éléments chargés dynamiquement
setTimeout(convertirDatesAirReviews, 1000);
setTimeout(convertirDatesAirReviews, 2000);

